import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'headingForGreetings'
	| 'descriptionForGreetings'
	| 'button'
	| 'descriptionForGreetingsConnie';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		headingForGreetings: {
			id: 'rovo-chat.rovo-onboarding-greetings.heading',
			defaultMessage: 'Meet Rovo, your AI teammate.',
			description: 'Intro header message for Rovo Chat Onboarding flow.',
		},
		descriptionForGreetings: {
			id: 'rovo-chat.rovo-onboarding-greetings.description',
			defaultMessage: 'AI that understands your Jira work so you can move faster, securely.',
			description: 'Intro description message for Rovo Chat Onboarding flow.',
		},
		button: {
			id: 'rovo-chat.rovo-onboarding-greetings.button',
			defaultMessage: 'Continue',
			description: 'Button text for Rovo Chat Onboarding flow.',
		},
		descriptionForGreetingsConnie: {
			id: 'rovo-chat.rovo-onboarding-greetings.description.connie',
			defaultMessage: 'AI that understands your Confluence work so you can move faster, securely.',
			description: 'Intro description message for Rovo Chat Onboarding flow.',
		},
	});

export default message;
